import { Link } from 'react-router-dom';
import './headerMain.css';
import { useContext, useState } from 'react';
import { cartContext } from '../App';
import Cookies from 'js-cookie';
import DeliveryTime from './subcomponents/deliveryTime';

export default function HeaderMain() {

    const { CartItem } = useContext(cartContext);
    const address = Cookies.get('address') === 'undefined' || Cookies.get('address') === undefined ? 'Select Address' : Cookies.get('address');
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    
    function close() {
        setShowDownloadButton(false);
    }
    
    return (
        <div className='header-main-container'>
            {
                showDownloadButton && 
                <div className='header-main-app-logo'>
                    <div className='header-main-app-logo-container'>
                        <img className='header-main-app-close-btn' src='/icons/close.png' alt='close-btn' onClick={close}/>
                        <img className='header-main-app-logo-img' src='/ic_launcher_rounded.png' alt='logo' />
                        <p className='header-main-app-name'>OnTimeUrban App</p>
                    </div>
                    <div className='header-main-app-logo-container-right'>
                        <Link to='https://play.google.com/store/apps/details?id=com.otu_android' style={{textDecoration: 'none'}}><p className='header-main-install-btn'>INSTALL</p></Link>
                    </div>
                </div>
            }
            <div className='header-main-container-top'>
                <div className='header-main-container-top-left'>
                    <div>
                        <DeliveryTime />
                        <div className='address-container'>
                            <Link to='/address-list' className='address'>{address?.length > 25 ? address.slice(0, 25) + "..." : address} &#9662;</Link>  
                        </div>
                    </div>
                </div>
                <div className='header-main-container-top-right'>
                    <div >
                        <Link to='/cart'>
                            <div className='cart-item-number'>
                                <span className='item-number'>{CartItem.length}</span>
                                <img className='cart-logo' src='/shopping-cart.png' />
                            </div>
                        </Link>
                    </div>
                    <div>
                        <Link to='/hamburger-menu'>
                            <div className='open-icon' style={{margin:'5px'}}></div>
                            <div className='open-icon' style={{margin:'5px'}}></div>
                            <div className='open-icon' style={{margin:'5px'}}></div>
                        </Link>
                    </div>
                </div>
            </div>
            <Link to='/search' style={{textDecoration: 'none'}}>
                <div className='header-main-container-bottom'>
                    <img src='/find.png' alt='search' className='header-main-search-logo' />
                    <p className='header-main-search-text'>Search for <span style={{fontWeight:'bold'}}>"Sugar"</span></p>
                </div>
            </Link>
        </div>
    );

}